























import Vue from 'vue'

export default Vue.extend({
    name: 'BaseContentContainer',

    computed: {
        isWide(): boolean {
            return this.$vuetify.breakpoint.mdAndUp
        },
    },
})
